<template>
  <div class="box-header">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            <small class="glyphicon glyphicon-filter"></small>
            Filtros
          </p>
        </div>
        <div class="card-body">
          <div class="box-body">
            <div class="row">
              <div class="form-group mb-2 col-12 col-md-2">
                <label for="segmentacao">Segmentacao Mensal</label>
              </div>
              <div class="form-group mb-2 col-12 col-md-4">
                <select
                  id="segmentacao"
                  v-model="filter.segmentacao"
                  style="width: 100%"
                  class="form-control"
                >
                  <!-- <option
                    v-for="item in segmentacoes"
                    v-bind:key="item.cd_segmentacao"
                    v-bind:value="item.descricao"
                  >{{ item.descricao }}</option> -->

                  <option style="background-color: #00a65a" value="Verde">Verde</option>
                  <option class="yellowColor" value="Amarelo">Amarelo</option>
                  <option class="redColor" value="Vermelho">Vermelho</option>
                </select>
              </div>
              <div class="form-group mb-2 col-12 col-md-2">
                <label for="motorista">Motorista</label>
              </div>
              <div class="form-group mb-2 col-12 col-md-4">
                <select
                  id="motorista"
                  v-model="filter.motorista_nome"
                  style="width: 100%"
                  class="form-control"
                >
                  <option
                    v-for="item in motoristas"
                    v-bind:key="item.cd_motorista"
                    v-bind:value="item.nome_motorista"
                  >{{ item.nome_motorista }}</option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="form-group mb-2 col-12 col-md-2">
                <label for="estado">Estado</label>
              </div>
              <div class="form-group mb-2 col-12 col-md-4">
                <select
                  id="estado"
                  v-model="filter.motorista_end_uf"
                  style="width: 100%"
                  class="form-control"
                  @change="onChangeEstado($event)"
                >
                  <option
                    v-for="estado in estados"
                    v-bind:key="estado.sigla"
                    v-bind:value="estado.sigla"
                  >{{ estado.nome }}</option>
                </select>
              </div>
              <div class="form-group mb-2 col-12 col-md-2">
                <label for="cidade">Cidade</label>
              </div>
              <div class="form-group mb-2 col-12 col-md-4">
                <select
                  id="cidade"
                  v-model="filter.motorista_end_cidade"
                  style="width: 100%"
                  class="form-control"
                >
                  <option
                    v-for="cidade in cidades"
                    :key="cidade.nome"
                    v-bind:value="cidade.nome"
                  >{{ cidade.nome }}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group mb-2 col-12 col-md-2">
                <label for="faixa">Faixa de Corridas</label>
              </div>
              <div class="form-group mb-2 col-12 col-md-4">
                <select id="faixa" v-model="filter.faixa" style="width: 100%" class="form-control">
                  <option value="0-99">0 - 99</option>
                  <option value="100-199">100 - 199</option>
                  <option value="200-299">200 - 299</option>
                </select>
              </div>
            </div>
          </div>
          <form>
            <div class="float-right pt-2">
              <button @click="pesquisar()" type="button" class="btn btn-primary btn-sm">
                Pesquisar
              </button>
              <button
                @click="clearFilter()"
                type="button"
                class="btn btn-danger btn-sm ml-4"
              >Limpar Filtro</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApuracaoMensalActions from '../../actions/ApuracaoMensalActions'
import EstadosCidades from '../../data/estados_cidades.json'
import EventBus from './EventBus'

export default {
  data () {
    return {
      titleModal: 'Reprovar Motorista',
      aplicativos: [],
      historico: null,
      filter: {
        segmentacao: null,
        motorista_nome: null,
        motorista_end_uf: null,
        motorista_end_cidade: null,
        faixa: null
      },
      historico_items: [],
      segmentacoes: [],
      motoristas: [],
      estados: [],
      cidades: []
    }
  },
  mounted () {
    var storageFilter = JSON.parse(localStorage.getItem('filter_performance'))

    if (storageFilter) {
      for (var key in this.filter) {
        this.filter[key] = storageFilter[key]
      }
    }

    this.estados = EstadosCidades.map(item => {
      const container = {}

      container.sigla = item.sigla
      container.nome = item.nome

      return container
    })

    if (this.filter.motorista_end_uf) {
      this.carregarCidades(this.filter.motorista_end_uf)
    }

    this.listarMotoristasPerformance()
    this.listarSegmentacoes()
  },
  methods: {
    listarMotoristasPerformance () {
      ApuracaoMensalActions.listarMotoristas().then(res => {
        this.motoristas = res
      })
    },
    listarSegmentacoes () {
      ApuracaoMensalActions.listarSegmentacoes().then(res => {
        this.segmentacoes = res
      })
    },
    pesquisar () {
      localStorage.setItem('filter_performance', JSON.stringify(this.filter))
      EventBus.$emit('pesquisar', JSON.stringify(this.filter))
    },
    onChangeEstado (event) {
      this.carregarCidades(event.target.value)
    },
    carregarCidades (estado) {
      localStorage.setItem('filter_performance', JSON.stringify(this.filter))

      var result = EstadosCidades.filter(obj => {
        return obj.sigla === estado
      })

      this.cidades = result[0].cidades.map(item => {
        const container = {}
        container.nome = item
        return container
      })
    },
    clearFilter () {
      for (var key in this.filter) {
        this.filter[key] = null
      }

      localStorage.removeItem('filter_performance')
      EventBus.$emit('pesquisar', JSON.stringify(this.filter))
    }
  }
}
</script>

<style>
.greenColor {
  background-color: #00a65a
}
.yellowColor {
  background-color: #f39c12
}
.redColor {
  background-color: #dd4b39
}
</style>



// WEBPACK FOOTER //
// src/pages/motorista/Filtro.vue